var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hotelDescriptionMainText)?_c('div',{staticClass:"aboutHotel__description-main-text"},[_c('article',[_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_setup.hotelDescriptionMainText)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }